<template>
  <div class="container-fluid">
    <BarreActions :actions="actions" @appliquer-action="executerAction($event)" />

    <div class="row" v-if="infosUser" >
      <div class="col-3"></div>
      <div class="col-6">
        <div class="card">
          <div class="card-header">
            Mes informations utilisateur
          </div>
          <div class="card-body m2">
            <div class="row">
              <span class="col-2">
                <div><b><label for="InputNom">Genre</label></b></div>
                <v-select id="SelectGenre" v-model="genreUser" :options="listeGenre" label="texte" value="valeur" style="width: 100%;"></v-select>
              </span>
              <span class="col-4">
                <div><b><label for="InputNom">Nom</label></b></div>
                <input id="InputNom" type="text" v-model="infosUser.nom" style="width: 100%;">
              </span>
              <span class="col-4">
                <div><b><label for="InputPreNom">Prénom</label></b></div>
                <input id="InputPreNom" type="text" v-model="infosUser.prenom" style="width: 100%;">
              </span>
              <span class="col-2">
                <div><b><label for="InputFonction">Fonction</label></b></div>
                <input id="InputFonction" type="text" v-model="infosUser.fonction" style="width: 100%;">
              </span>
            </div>
            <br/>
            <div class="row">
              <span class="col-3">
                <div><b><label for="InputTelPortable">Téléphone Portable</label></b></div>
                <input id="InputTelPortable" type="text" v-model="infosUser.telephonePortable" style="width: 100%;">
              </span>  
              <span class="col-3">
                <div><b><label for="InputTelFixe">Téléphone Fixe</label></b></div>
                <input id="InputTelFixe" type="text" v-model="infosUser.telephoneFixe" style="width: 100%;">
              </span>  
              <span class="col-6">
                <div><b><label for="InputEmail">Email</label></b></div>
                <input id="InputEmail" type="text" v-model="infosUser.email" style="width: 100%;">
              </span>                
            </div>
          </div>
        </div>
      </div>
      <div class="col-3"></div>
    </div>
  </div>
</template>
<script>
import { connecteData } from "@/mixins/connecteData"
import { alerteDonneesModifiees } from "@/mixins/index"
import { currentUserInfo, modifierInfosUser, obtenirListeGenre } from '@/api/gpao/user'
import BarreActions from '@/components/Divers/BarreActions'
import _ from 'lodash'


export default {
  name: "profil",
  mixins: [ connecteData, alerteDonneesModifiees ],
  components: { BarreActions },
  data() {
    return {
      contenuPage: "",
      infosUser: {},
      donneesInitialesUser: {},
      genreUser: {},
      genreUserInitial: {},
      listeGenre: [],
      actions: {
        // Boutons à afficher dans la barre d'action
        // Exemple :
        /*
        nomAction: {
          label: Label affiché sur le bouton (string),
          disabled: Etat actif/inactif par défaut du bouton (bool),
          class: Classe CSS (btn-primary, btn-success, btn-warning ou btn-danger) à appliquer sur le bouton (par défaut : "btn-primary" est appliqué => il s'agit du bouton bleu Agap'pro) (string)
          methode(contexte) {
            // => contexte équivaut à this (mais this ne fonctionne pas car l'initialisation de data n'est pas encore terminée, donc data n'est pas encore rattaché à this)
            traitements à exécuter lors du clic sur le bouton
            les traitements définis dans cette page doivent être appelés sous la forme : contexte.traitement()

            Remarque : pour que le système fonctionne, il faut déclarer la méthode ci-dessous dans la section "methods" de cette page
            executerAction(methode) {
              methode(this)
            }

          }
        }
        */
        annuler: {
          label: "Annuler",
          disabled: true,
          class: "btn-danger",
          methode(contexte) {
            contexte.infosUser = _.cloneDeep(contexte.donneesInitialesUser) 
            contexte.genreUser = _.cloneDeep(contexte.genreUserInitial) 
          }
        },
        enregistrer: {
          label: "Enregistrer",
          disabled: true,
          class: "btn-success",
          methode(contexte) {
            contexte.enregistrerModification()  
          }
        },
        // Appeler "this.actions.initialiser(this)"" dans mounted() => génère les tableaux d'actions utilisés pour afficher les boutons à gauche et à droite de la barre d'actions
        barreGauche: [],
        barreDroite: [],
        initialiser(contexte) {
          contexte.actions.barreGauche = [ ]
          contexte.actions.barreDroite = [ contexte.actions.annuler, contexte.actions.enregistrer ]
        },
        // A gérer en cas de boutons à activer/désactiver (créer une méthode par groupe de boutons à activer/désactiver)
        disable(actions, disabled) {
          let actionsATraiter = [ actions.annuler, actions.enregistrer ]
          actionsATraiter.forEach(a => a.disabled = disabled)
        }
      }
    }
  },
  
  computed: {
    donneesModifiees() {
      return (this.donneesInitialesUser && this.infosUser && !_.isEqual(JSON.stringify(this.donneesInitialesUser), JSON.stringify(this.infosUser))) || 
             (this.genreUserInitial && this.genreUser && !_.isEqual(JSON.stringify(this.genreUserInitial), JSON.stringify(this.genreUser)))
    }
  },
  watch: {
    donneesModifiees() {
      if (this.donneesModifiees) {
        this.actions.disable(this.actions, false)
      } else {
        this.actions.disable(this.actions, true)
      }
    }
  },
  validations: {
    
  },
  methods: {
    executerAction(methode) {
      // Nécessaire pour faire fonctionner les actions de la barre d'actions'
      methode(this)
    },
    adresseMonCompte() {
      let adr = process.env.VUE_APP_BASE_BO
      return adr + "/Fournisseurs/Account/LoginFromAnotherSite?ReturnUrl=%2FFournisseurs%2FMonCompte"
    },
    async chargerDonnees() {
      this.$store.commit('uxHelpers/showSpinner')

      let tmpUser = await currentUserInfo()
      this.infosUser = tmpUser.data

      let tmp = await obtenirListeGenre()
      this.listeGenre = tmp.data
      
      this.genreUser = this.listeGenre.find(t => t.valeur === this.infosUser.genreId)

      this.genreUserInitial = _.cloneDeep(this.genreUser)
      this.donneesInitialesUser = _.cloneDeep(this.infosUser)

      this.$store.commit('uxHelpers/hideSpinner')
    },
    async enregistrerModification() {
      //On enregistre les infos user et fournisseur en meme temps, via deux API
      this.infosUser.genreAbreviation = this.genreUser.texte
      this.infosUser.genreId = this.genreUser.valeur
      await modifierInfosUser(this.infosUser)

      await this.chargerDonnees()

      await this.alerteSucces("Modifications enregistrées")
    }
  },
  created() {
    // Déclenche un verrou et un message à la fermeture du navigateur si des données sont en cours de modification (Le message est déclenché si la valeur retournée est différente de null)
    window.onbeforeunload = (() => {
      if (this.donneesModifiees)
        return true
      return null
    })
  },
  
  async mounted() {
    this.actions.initialiser(this)
    await this.chargerDonnees()
  }
}
</script>

